import { Outlet } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useEncryption } from '@/context/EncryptionContext';
import RecoveryKeySetup from './RecoveryKeySetup';
import RecoveryKeyUnlock from './RecoveryKeyUnlock';

/**
 * Route layout for the authenticated area. Interrupts with encryption screens
 * when the user must save a recovery key or unlock a new device; otherwise
 * renders the app. New users are silently provisioned a standard key by
 * EncryptionContext (private max is opt-in via Settings), so 'loading'/'ready'
 * fall through and standard-mode users keep the current snappy flow (entry
 * decryption is gated downstream by EczemaDataContext).
 */
const EncryptionGate = () => {
  const { status, retry } = useEncryption();

  switch (status) {
    case 'setup-recovery':
      return <RecoveryKeySetup />;
    case 'needs-recovery-key':
      return <RecoveryKeyUnlock />;
    case 'error':
      return (
        <div className="min-h-screen bg-background flex items-center justify-center px-4">
          <div className="text-center space-y-4">
            <p className="text-muted-foreground">
              We couldn't unlock your encrypted data. Please try again.
            </p>
            <Button onClick={retry}>Retry</Button>
          </div>
        </div>
      );
    default:
      return <Outlet />;
  }
};

export default EncryptionGate;
